import { render, staticRenderFns } from "./detailLog.vue?vue&type=template&id=6d55fba8&scoped=true&"
import script from "./detailLog.vue?vue&type=script&lang=js&"
export * from "./detailLog.vue?vue&type=script&lang=js&"
import style0 from "./detailLog.vue?vue&type=style&index=0&id=6d55fba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d55fba8",
  null
  
)

export default component.exports